import React, { FC, memo } from 'react';
import testingVar from 'utils/testingVar';
import { Props } from './types';
import {
  AccountDropdown,
  Container,
  Content,
  MenuButton,
  MenuIcon,
  AccountPlaceholder,
  Link,
  Help,
  HelpIcon,
} from './styles';

const TopBar: FC<Props> = ({
  name,
  photo,
  email,
  initials,
  plan,
  openMenu,
  onLogout,
  onAccountSwitch,
  ...props
}) => {
  const shouldShowUpgradePlanButton =
    plan === 'FREE' &&
    !window.location.pathname.startsWith('/settings/billing');
  return (
    <Container {...props}>
      {openMenu && (
        <MenuButton data-test-id={testingVar('submit-open')} onClick={openMenu}>
          <MenuIcon />
        </MenuButton>
      )}
      <Content />
      {shouldShowUpgradePlanButton && (
        <Link to="/settings/billing" data-test-id="upgrade-plan">
          Upgrade plan
        </Link>
      )}
      <Help
        href="https://support.yet-another-mail-merge.com/hc/en-us"
        target="_blank"
        rel="noopener noreferrer"
      >
        <HelpIcon />
      </Help>
      {name && email ? (
        <AccountDropdown
          {...{ name, photo, email, initials, onLogout, onAccountSwitch }}
        />
      ) : (
        <div>
          <AccountPlaceholder />
        </div>
      )}
    </Container>
  );
};

export default memo(TopBar);
